import { Typography, Link } from '@mui/material';
import { Trans as I18NextTrans } from 'react-i18next';

const TRANS_COMPONENTS = {
  bold: <Typography component="span" variant="subtitle2" />,
  a: <Link />,
};

const createTransWithComponents = () => {
  const TransWithComponents: typeof I18NextTrans = (props) => (
    <I18NextTrans {...props} components={props.components ?? TRANS_COMPONENTS} />
  );
  return TransWithComponents;
};

export const Trans = createTransWithComponents();
